<template>
  <pt-gene-lab-order class="pt-gene-lab-order__page" ref="detail"></pt-gene-lab-order>
</template>

<script>
import PtGeneLabOrder from 'cps/lab-order/pt-gene-lab-order/withData'
export default {
  name: 'pt-gene-lab-order__view',
  components: {
    'pt-gene-lab-order': PtGeneLabOrder
  },
  beforeRouteUpdate (to, from, next) {
    // console.log('----------to', to)
    // if (to.fullPath === '/gene-lab-order') {
    //   console.log('----------to', JSON.stringify(to))
    //   this.$refs.detail.reload(to.query)
    // }
    next()
  }
}
</script>
